<template>
    <section :class="theme === 'dark' ? 'tw-bg-[#1A1D21]' : 'tw-bg-white'" class="tw-rounded-2xl tw-shadow-2xl tw-overflow-hidden">
        <div :class="theme === 'dark' ? 'tw-bg-slate-800 tw-border-slate-700' : 'tw-bg-slate-50 tw-border-slate-200'" class="tw-border-b tw-p-6 tw-flex tw-items-center tw-justify-between">
            <h3 :class="theme === 'dark' ? 'tw-text-slate-100' : 'tw-text-slate-900'" class="tw-font-bold tw-text-lg">Informações gerais</h3>
            <div class="tw-w-10 tw-h-10 tw-rounded-xl tw-flex tw-items-center tw-justify-center">
                <i :class="theme === 'dark' ? 'tw-text-slate-300' : 'tw-text-slate-700'" class="fas fa-info"></i>
            </div>
        </div>
        <div class="tw-p-6 tw-space-y-6">
            <div v-if="silo.programa" class="tw-space-y-3">
                <div :class="theme === 'dark' ? 'tw-text-slate-300' : 'tw-text-slate-700'" class="tw-flex tw-justify-between tw-text-sm">
                    <span>Produto:</span>
                    <span class="tw-font-semibold">{{ silo.produto.descricao }}</span>
                </div>
                <div :class="theme === 'dark' ? 'tw-text-slate-300' : 'tw-text-slate-700'" class="tw-flex tw-justify-between tw-text-sm">
                    <span>Programa:</span>
                    <span class="tw-font-semibold">{{ silo.programa.descricao }}</span>
                </div>
                <div :class="theme === 'dark' ? 'tw-text-slate-300' : 'tw-text-slate-700'" class="tw-flex tw-justify-between tw-text-sm">
                    <span>Média Atual:</span>
                    <span class="tw-font-semibold">{{ `${silo.media_atual} °C` }}</span>
                </div>
                
                <div :class="theme === 'dark' ? 'tw-text-slate-300' : 'tw-text-slate-700'" class="tw-flex tw-justify-between tw-items-center tw-text-sm">
                    <span>Aeração:</span>
                    <span :class="silo.bloqueio_aeracao == 1 ? (theme === 'dark' ? 'tw-bg-red-500/20 tw-text-red-300' : 'tw-bg-red-50 tw-text-red-700') : (theme === 'dark' ? 'tw-bg-emerald-500/20 tw-text-emerald-300' : 'tw-bg-emerald-50 tw-text-emerald-700')" class="tw-px-3 tw-py-1 tw-rounded-full tw-text-xs tw-font-semibold">
                        {{ silo.bloqueio_aeracao == 1 ? "Bloqueada" : "Liberada" }}
                    </span>
                </div>
                
                <div :class="theme === 'dark' ? 'tw-text-slate-300' : 'tw-text-slate-700'" class="tw-flex tw-justify-between tw-text-sm">
                    <span>Aeração últimas 24h:</span>
                    <span class="tw-font-semibold">{{ aeracaoUltimas24h }}</span>
                </div>
                
                <div :class="theme === 'dark' ? 'tw-text-slate-300' : 'tw-text-slate-700'" class="tw-flex tw-justify-between tw-text-sm">
                    <span>Temperatura de Alerta:</span>
                    <span class="tw-font-semibold">{{ `${silo.temperatura_alerta} °C` }}</span>
                </div>
                
                <div :class="theme === 'dark' ? 'tw-text-slate-300' : 'tw-text-slate-700'" class="tw-flex tw-justify-between tw-items-center tw-text-sm">
                    <span>Leituras Automáticas:</span>
                    <span :class="silo.bloqueio_aeracao == 0 ? (theme === 'dark' ? 'tw-bg-emerald-500/20 tw-text-emerald-300' : 'tw-bg-emerald-50 tw-text-emerald-700') : (theme === 'dark' ? 'tw-bg-red-500/20 tw-text-red-300' : 'tw-bg-red-50 tw-text-red-700')" class="tw-px-3 tw-py-1 tw-rounded-full tw-text-xs tw-font-semibold">
                        {{ silo.bloqueio_aeracao == 0 ? "Habilitado" : "Desabilitado" }}
                    </span>
                </div>
            </div>
            <div class="tw-space-y-4">
                <div class="tw-flex tw-items-center tw-justify-between">
                    <div>
                        <p :class="theme === 'dark' ? 'tw-text-slate-400' : 'tw-text-slate-500'" class="tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wider">Nível</p>
                        <p :class="theme === 'dark' ? 'tw-text-slate-100' : 'tw-text-slate-900'" class="tw-text-2xl tw-font-bold">
                            {{ silo.tipo_nivel == 1 ? (silo.nivel_automatico % 1 == 0 ? silo.nivel_automatico : silo.nivel_automatico.toFixed(1)) : silo.nivel_manual }}%
                        </p>
                    </div>
                    <span :class="silo.tipo_nivel == 1 ? (theme === 'dark' ? 'tw-bg-blue-500/20 tw-text-blue-300' : 'tw-bg-blue-50 tw-text-blue-700') : (theme === 'dark' ? 'tw-bg-amber-500/20 tw-text-amber-300' : 'tw-bg-amber-50 tw-text-amber-700')" class="tw-px-3 tw-py-1 tw-rounded-full tw-text-xs tw-font-semibold">
                        {{ silo.tipo_nivel == 1 ? "Automático" : "Manual" }}
                    </span>
                </div>
                <div :class="theme === 'dark' ? 'tw-bg-slate-700' : 'tw-bg-slate-200'" class="tw-w-full tw-h-3 tw-rounded-full tw-overflow-hidden">
                    <div 
                        class="tw-h-full tw-bg-gradient-to-r tw-from-emerald-500 tw-to-emerald-600"
                        :style="{ width: (silo.tipo_nivel == 1 ? silo.nivel_automatico : silo.nivel_manual) + '%' }"
                    ></div>
                </div>
                <p :class="theme === 'dark' ? 'tw-text-slate-400' : 'tw-text-slate-500'" class="tw-text-center tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wider tw-mt-0">{{carga_atual}}/{{silo.capacidade}} sacas</p>
            </div>
            <div :class="theme === 'dark' ? 'tw-border-slate-700' : 'tw-border-slate-200'" class="tw-border-t">
                <CanvasVista :cabos="silo.cabos" :silotipo="silo.tipo" :theme="theme" />
            </div>
        </div>
    </section>
</template>

<script>
import CanvasVista from "./CanvasVista.vue";

export default {
    components: {
        CanvasVista
    },
    props: {
        silo: {
            type: Object,
            default: () => ({}),
        },
        theme: {
            type: String,
            default: 'light'
        }
    },
    data() {
        return {
            CanvasVista,
        };
    },
    computed: {
        carga_atual() {
            if (this.silo && this.silo.tipo_nivel && (this.silo.nivel_automatico || this.silo.nivel_manual)) {
                const nivel =  this.silo.tipo_nivel == 1 ? this.silo.nivel_automatico : this.silo.nivel_manual;
                const carga_atual = Math.round(this.silo.capacidade * nivel / 100);
                return carga_atual
            }
            return 0
        },
        aeracaoUltimas24h() {
            if (this.silo && this.silo.aeracao && this.silo.aeracao.horas_aeradas) {
                let totalSegundos = this.silo.aeracao.horas_aeradas.horas_day;
                let horas = Math.floor(totalSegundos / 3600);
                let minutos = Math.floor((totalSegundos % 3600) / 60);
                let segundos = totalSegundos % 60;

                return `${horas} Hrs ${minutos} min ${segundos} s`;
            }
            return "0 s";
        }
    }
};
</script>
